module.exports = __webpack_public_path__ + "static/media/bell-active.b66373c6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/bell-active.svg
// module id = 2561
// module chunks = 0